// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"fbc515e2","484":"fbc515e2"}[chunkId] + ".chunk.css";
};